import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonRouterLink,
  IonText,
} from "@ionic/react";
// import ExploreContainer from '../components/ExploreContainer';
import "./Tab1.css";
import React from "react";
import { IonSlides, IonSlide } from "@ionic/react";
import {
  IonCard,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCardContent,
  IonIcon,
} from "@ionic/react";
import {
  logoWhatsapp,
  logoFacebook,
  callOutline,
  logoInstagram,
  readerOutline,
  helpOutline,
} from "ionicons/icons";
import { IonGrid, IonRow, IonCol } from "@ionic/react";
const Tab1: React.FC = () => {
  const slideOpts = {
    initialSlide: 0,
    slidesPerView: 1,
    autoplay: true,
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>
            <b>ওষুধ & Etc</b>
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Medicine & Etc 2</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonSlides pager={true} options={slideOpts}>
            <IonSlide>
              <IonCard>
                <IonCardHeader>
                  <IonCardSubtitle>Card Subtitle</IonCardSubtitle>
                  <IonCardTitle>Card Title 1</IonCardTitle>
                </IonCardHeader>

                <IonCardContent>
                  Keep close to Nature's heart... and break clear away, once in
                  awhile, and climb a mountain or spend a week in the woods.
                  Wash your spirit clean.
                </IonCardContent>
              </IonCard>
            </IonSlide>
            <IonSlide>
              <IonCard>
                <IonCardHeader>
                  <IonCardSubtitle>Card Subtitle</IonCardSubtitle>
                  <IonCardTitle>Card Title 2</IonCardTitle>
                </IonCardHeader>

                <IonCardContent>
                  Keep close to Nature's heart... and break clear away, once in
                  awhile, and climb a mountain or spend a week in the woods.
                  Wash your spirit clean.
                </IonCardContent>
              </IonCard>
            </IonSlide>
            <IonSlide>
              <IonCard>
                <IonCardHeader>
                  <IonCardSubtitle>Card Subtitle</IonCardSubtitle>
                  <IonCardTitle>Card Title 3</IonCardTitle>
                </IonCardHeader>

                <IonCardContent>
                  Keep close to Nature's heart... and break clear away, once in
                  awhile, and climb a mountain or spend a week in the woods.
                  Wash your spirit clean.
                </IonCardContent>
              </IonCard>
            </IonSlide>
          </IonSlides>
          <IonText color="tertiary">
            <h2 className="Order-via-text"> অর্ডার মাধ্যম </h2>
          </IonText>
          <IonGrid>
            <IonRow className="ion-align-items-center">
              <IonCol size="4">
                <IonRouterLink
                  color="tertiary"
                  href="https://api.whatsapp.com/send?phone=919153167709&amp;text=I%20want%20to%20find%20out%20about%20your%20products
"
                >
                  <IonIcon
                    className="icon-whatsapp"
                    icon={logoWhatsapp}
                    size="large"
                  />
                  হোয়াটসঅ্যাপ
                </IonRouterLink>
              </IonCol>
              <IonCol size="4">
                <IonRouterLink
                  color="tertiary"
                  href="https://m.me/medicineandetc"
                >
                  <IonIcon
                    className="icon-fb"
                    icon={logoFacebook}
                    size="large"
                  />
                  ম্যাসেঞ্জার
                </IonRouterLink>
              </IonCol>
              <IonCol size="4">
                <IonRouterLink
                  color="tertiary"
                  href="https://m.me/medicineandetc"
                >
                  <IonIcon
                    className="icon-fb"
                    icon={callOutline}
                    size="large"
                  />
                  ফোন কল
                </IonRouterLink>
              </IonCol>
            </IonRow>
            <IonRow className="ion-align-items-center">
              <IonCol size="4">
                {" "}
                <IonRouterLink
                  color="tertiary"
                  href="https://m.me/medicineandetc"
                >
                  <IonIcon
                    className="icon-fb"
                    icon={logoInstagram}
                    size="large"
                  />
                  ইনস্টাগ্রাম
                </IonRouterLink>
              </IonCol>
              <IonCol size="4">
                <IonRouterLink
                  color="tertiary"
                  href="https://m.me/medicineandetc"
                >
                  <IonIcon
                    className="icon-fb"
                    icon={readerOutline}
                    size="large"
                  />
                  মেডিসিন কার্ড
                </IonRouterLink>
              </IonCol>
              <IonCol size="4">
                <IonRouterLink
                  color="tertiary"
                  href="https://m.me/medicineandetc"
                >
                  <IonIcon
                    className="icon-fb"
                    icon={helpOutline}
                    size="large"
                  />
                  ইত্যাদি
                </IonRouterLink>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
      </IonContent>
    </IonPage>
  );
};

export default Tab1;
